import OneLineLoader from './OneLineLoader';

export default OneLineLoader;
